<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>嘗試演示，看看Trinka的實際應用。</h1>
                        <span>借助此免費且功能強大的文法檢查工具，可立即修訂您的英語寫作。Trinka讓您的寫作變得輕鬆自如。</span>
                        <!-- <a href="http://demo.trinka.ai/" target="_blank">現在就試試</a> -->
                        <a href="https://cloud.trinka.ai/signup?utm_source=try-a-demo&utm_medium=tw&utm_campaign=signup" target="_blank">現在就試試</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>適用於學術和技術寫作的最佳文法和語言校正AI工具</h2>
                    <p>Trinka是最好的英語文法檢查工具，可以立即增強和檢查您的寫作。 它的高級檢查功能可突出顯示錯誤並提供上下文建議，從而使您的寫作煥然一新。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>發現其它工具不能發現的複雜錯誤</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka的功能遠遠超越了簡單的文法檢查，它還能發現學術寫作、科學語氣和風格所特有的難以檢查的錯誤。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>技術用詞選擇</h4>
                            <p>Yield strength values, defined from <span class="wrong_text"> cycling</span> <span
                                    class="right_text"> cyclic</span> aging tests, are used for the parameterization of
                                the model.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>專為學術和技術寫作而設計</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka專為幫助學者和技者作家而構建，可糾正3000多種複雜的文法錯誤和蹩腳的句子結構。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>句法</h4>
                            <p>The virus <span class="wrong_text"> is not requiring</span> <span class="right_text">
                                    does not require</span> us to <span class="wrong_text">remain</span> <span
                                    class="right_text"> stay</span> away from our communities.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>建議與您的主題有關的更改</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>一個由Al驅動的文法檢查工具，已從數百萬篇最佳的研究論文和文章中學習，為您提供最佳建議。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>高級拼寫</h4>
                            <p>Grind tissue in <span class="wrong_text">Trizol reagent</span> <span class="right_text">
                                    TRIzol® Reagent</span> using a disposable <span class="wrong_text">pestel</span>
                                <span class="right_text"> pestle</span> and centrifuge for 10 min at 4°C.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>超越標準文法的校正</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka吸收了經驗豐富的編輯和語言學家的專業知識。結果顯而易見——它是最好的語言增強工具。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <h4>敏感語言</h4>
                            <p>Eighty-eight percent were male and <span class="wrong_text">committed</span> <span
                                    class="right_text"> died by</span> suicide at a mean age of 25.6 years.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>準備提高您的寫作技巧？</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" id="grammerSignUpButton">
                        <i class="fa fa-sign-in"></i>
                        <span>免費註冊</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>使用感言</h2>
                    <p>查看用戶對Trinka的評價</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>我一下就愛上Trinka了。祝賀你們開發出這個可以廣泛協助編輯的程式，尤其是符合重要的文法慣例和具備精簡字數功能的工具。</p>
                    <div class="testimonals_footer">
                        <p>學術編輯, 美國</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>這是一個超越Grammarly的文法檢查工具！我用Trinka重新檢查了Grammarly檢查過的幾份文檔。看到來自印度的如此優越產品，我感到非常驚喜！</p>
                    <div class="testimonals_footer">
                        <p>放射科醫師, 印度</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="">
                    </div>
                    <p>我測試了Trinka，對其出色的功能印象深刻。它比我使用的語法檢查器要好，我已經告訴研究實驗室的同事使用Trinka。希望它在學術界得到廣泛的應用。</p>
                    <div class="testimonals_footer">
                        <p>英國博士學者</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>